import { Injectable, Input } from '@angular/core';
import { Constants } from 'src/app/shared/constants';
import { BaseHttpService } from 'src/app/shared/services/basehttp.service';
import { GroupModel, UserGroupDataModel } from 'src/app/admin/models/group.model';

@Injectable()

export class ShareDialogService {

    
    constructor(private baseHttpService: BaseHttpService) {}

    addGroupInfo(shareId: string, selGroupList:GroupModel[], shareapiPath: string) {
        const [group] = [selGroupList.map(grp => grp.groupId)];
        return this.baseHttpService.post(shareapiPath, {
            'shareId': shareId,           
            'groups': group          
        })
        
    }
    addUserInfo(surveyId: string, users: UserGroupDataModel, shareapiPath: string) {
        const [user, group] = [users.users, users.groups.map(grp => grp.groupId)];
        return this.baseHttpService.post(shareapiPath, {
            'surveyId': surveyId,
            'userType': 3,  // 0 - Admin, 1 - Shared Results, 2 - Send Survey
            'users': user,
            'groups': group,
            'userActivityLog':users.userActivityLog
        })
        
    }
}